/**
 * Backend list endpoints in this codebase return inconsistent shapes:
 *   - `[item, item]`                    (bare array)
 *   - `{ data: [...], total: N }`       (paged wrapper)
 *   - `{ devices: [...], count: N }`    (named wrapper)
 *   - `{ groups: [...] }`, `{ trips: [...] }`, …
 *   - `null` (when the underlying SQL returned no rows)
 *
 * `unwrapList<T>(raw)` returns a guaranteed `T[]` for any of the above.
 */
export function unwrapList<T>(raw: unknown): T[] {
  if (raw == null) return []
  if (Array.isArray(raw)) return raw as T[]
  if (typeof raw !== 'object') return []
  const o = raw as Record<string, unknown>

  // Prefer "data" key first (most common paged wrapper)
  if (Array.isArray(o.data)) return o.data as T[]

  // Otherwise, find the first value that is an array
  for (const v of Object.values(o)) {
    if (Array.isArray(v)) return v as T[]
  }

  return []
}
